import { render, staticRenderFns } from "./bankDetails.vue?vue&type=template&id=115ecc6e&scoped=true&"
import script from "./bankDetails.vue?vue&type=script&lang=js&"
export * from "./bankDetails.vue?vue&type=script&lang=js&"
import style0 from "./bankDetails.vue?vue&type=style&index=0&id=115ecc6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115ecc6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VSkeletonLoader})
